export default __webpack_public_path__ + "static/media/hero-image.4dc12180.png";